import { Component, ElementRef, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IKCard, KCardFieldType } from 'ng-k-card';
import { KIconType } from 'ng-k-icon';
import { KUtilsService as Utils } from 'ng-k-utils';
import { KButtonType, KKcgButtonSubType } from 'ng-k-button';
import { ActivatedRoute, Router } from '@angular/router';
import { ClaimsService } from 'src/app/services/claims.service';
import * as moment from 'moment';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';
import { KModalService } from 'ng-k-modal';
import { KNotificationsService } from 'ng-k-notifications';
import { NihlOutlineExposureService } from 'src/app/services/nihl-outline-exposure.service';
import { FormBuilder } from '@angular/forms';
import { SharedService } from 'src/app/services/shared.service';
import { OauthPlusService } from 'src/app/services/oauth-plus.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-claim-detail',
  templateUrl: './claim-detail.component.html',
  styleUrls: ['./claim-detail.component.scss']
})
export class ClaimDetailComponent implements OnInit {
  @ViewChild('confirmDeleteTest', { static: true }) confirmDeleteTest!: TemplateRef<any>;
  KButtonType = KButtonType;
  KKcgButtonSubType = KKcgButtonSubType;
  public claimId = '';
  public antigenMarkers = [];
  public claimInfo: IKCard = {};
  public claimInfo2: IKCard = {};
  public workflowData = [];
  public createAudiometryTaskId = '';
  public claimData: any = [];
  public displaySuccess: boolean = false;
  public displayError: boolean = false;
  public successText!: string;
  public errorText!: string;
  public timeout!: number;
  public filter: any = {};
  public isDeleteClaimsAllowed: boolean = false;
  public isDeleteMedReportsAllowed: boolean = false;
  public allAudiometryTests = [];
  public searchMedicalRecordsFilterForm: any = {};
  public selectedTest: any = {};

  public tabMedical: boolean = false;
  public tabTasks: boolean = true;
  public tabOutcome: boolean = false;
  public tabToDisplay: any = '';
  public selectedTabs: any = [];
  public data: any[] = [];
  public customData: any;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private claimsService: ClaimsService,
    private router: Router,
    private loaderService: GlobalLoadingService,
    private kmodalService: KModalService,
    private modalService: NgbModal,
    private notificationsService: KNotificationsService,
    private nihlOutlineExposureService: NihlOutlineExposureService,
    private sharedService: SharedService,
    private fb: FormBuilder,
    private _auth: OauthPlusService
  ) { }

  ngOnInit(): void {
    this._auth.$whenUserLoaded.subscribe((data: boolean) => {
      if (data) {
        this.getRightsByToken();
      }
    });
    this.route.params.subscribe(params => {
      this.claimId = decodeURIComponent(params['id']);
      this.tabToDisplay = params['tab'];
      if (this.tabToDisplay == 'medical') {
        this.tabMedical = true;
        this.tabTasks = false;
        this.tabOutcome = false;
      } else
        if (this.tabToDisplay == 'outcome') {
          this.tabMedical = false;
          this.tabTasks = false;
          this.tabOutcome = true;
        } else {
          this.tabMedical = false;
          this.tabTasks = true;
          this.tabOutcome = false;
        }

    });
    this.getWorkflowOverview(this.claimId);
    // setting the pixels of header
    this.notificationsService.$initialPixelHeadValue.next(160);
  }

  public getClaimInfo(claimID: any) {
    this.loaderService.startLoadingIndicator('getClaimInfo');
    this.claimInfo = {
      value: '',
      header: {
        label: moment(new Date(this.claimData.claim.createdDate)).format('DD/MM/YYYY'),
        labelColour: 'brand-main',
        icon: {
          type: KIconType.fas,
          name: 'clock'
        }
      },
      clickable: false,
      fields: [
        {
          fieldType: KCardFieldType.IdRef,
          label: 'Claim Reference',
          value: this.claimData?.claimant?.claimReference ? this.claimData?.claimant?.claimReference : ' ',
          icon: {
            type: KIconType.fas,
            name: 'tag',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'Claimant Name',
          value: this.claimData.claimant.claimantName,
          icon: {
            type: KIconType.fas,
            name: 'user',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'Condition',
          value: this.claimData.claimant.condition,
          icon: {
            type: KIconType.fas,
            name: 'stethoscope',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Link,
          label: 'Open >',
          value: '/claimForm/' + encodeURIComponent(this.claimId),
        }
      ]
    }
    let amountSymbol = ''

    this.claimInfo2 = {
      value: '',
      clickable: false,
      fields: [
        {
          fieldType: KCardFieldType.IdRef,
          label: 'Claim Amount',
          value: this.claimData.claim.claimAmount != 0 ? this.claimData.claim.claimAmount : '0',
          icon: {
            type: KIconType.fas,
            name: 'wallet',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'No. of Defendants',
          value: this.claimData.claim.noOfDefendants ? this.claimData.claim.noOfDefendants : ' ',
          icon: {
            type: KIconType.kennedys,
            name: 'defendant',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'No. of Insurers',
          value: this.claimData.claim.insurersInfo.value + ' Insurer(s)',
          icon: {
            type: KIconType.kennedys,
            name: 'insurer',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: this.claimData.claim.employersInfo.type == 'name' ? 'Employer name' : 'No. of Employers',
          value: this.claimData.claim.employersInfo.type == 'name' ? (this.claimData.claim.employersInfo.value) : (this.claimData.claim.employersInfo.value + ' Employer(s)'),
          icon: {
            type: KIconType.fas,
            name: 'user-tie',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Link,
          label: 'Full Apportionment >',
          value: '/claimForm/' + encodeURIComponent(this.claimId),
        }
      ]
    }
    this.loaderService.stopLoadingIndicator('getClaimInfo');
  }

  public capFirstLetter(word: any): string {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }
  public getWorkflowOverview(claimID: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimID ? claimID : null;
    this.loaderService.startLoadingIndicator('getWorkflowOverview');

    thisObj.claimsService.getWorkflowOverview(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getWorkflowOverview');
        this.workflowData = result.data.overview;
        this.selectedTabs = result.data.activeTabs;
        for (var i = 0; i < result.data.overview.length; i++) {
          if (result.data.overview[i].workFlowNodeName == 'Investigation') {
            for (var j = 0; j < result.data.overview[i].tasks.length; j++) {
              if (result.data.overview[i].tasks[j].handle == 'create-audiometry') {
                this.createAudiometryTaskId = result.data.overview[i].tasks[j].taskId;
                this.searchMedicalRecordsFilterFormValidation();
                this.getAllAudiometryTestList(null);
              }
            }

          }
        }

        this.claimData = result.data.meta;
        this.customData =        
        {
            claimId : this.claimId,
            claimantName : this.claimData.claimant.claimantName,
        }
        this.getClaimInfo(this.claimId);
      }

      if (result.status === 'Unprocessable') {
      }
    },
      err => {
        console.log(err.error);
        this.loaderService.stopLoadingIndicator('getWorkflowOverview');
        if (err.error.status === 'Unprocessable') {
          this.loaderService.stopLoadingIndicator('getWorkflowOverview');
          this.workflowData = [];
          this.claimData = [];
          this.errorText = err.error.Message;
          this.showMessage('error', 2000);
        }
      });
  }

  public searchMedicalRecordsFilterFormValidation() {
    this.searchMedicalRecordsFilterForm = this.fb.group({
      keyword: '',
    });
  }

  public taskAction(task: any, claimID: any) {
    let action = task['action'];
    let taskId = task['taskId'];
    let handle = task['handle'];
    if (handle == 'compare-audiograms') {
      this.router.navigate([action, claimID, taskId, this.createAudiometryTaskId])
    } else {
      this.router.navigate([action, claimID, taskId])
    }
    if (handle == 'create-profile') {
      this.router.navigate([action, claimID])
    }
    if(handle == 'assess-contribution-to-cost'){
      this.router.navigate([action,claimID,taskId])
    }

  }

  public getAllAudiometryTestList(keyword: any) {
    this.loaderService.startLoadingIndicator('getAllAudiometryTestList');
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId ? this.claimId : null;
    requestParam.taskId = this.createAudiometryTaskId ? this.createAudiometryTaskId : null;
    requestParam.actionName = 'audiometry_view_all';
    requestParam.payload = {
      'search': keyword ? keyword : ''
    };

    thisObj.nihlOutlineExposureService.getAllAudiometryTestList(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        thisObj.allAudiometryTests = [];
        this.loaderService.stopLoadingIndicator('getAllAudiometryTestList');
        thisObj.allAudiometryTests = result.data;
      }
    }, err => {
    });
  }

  public confirmDeleteClaim(template: any) {
    // this.kmodalService.setIsOpen('deleteClaimModal',true);
    // let text = "Delete " + this.claimData?.claimant?.claimantName + "'s " + this.claimData?.claimant?.condition + " claim? This cannot be undone.";
    //   if (confirm(text) == true) {
    //     text = "You pressed OK!";
    //     this.deleteClaim();
    //   } else {
    //     text = "You canceled!";
    //   }

    const modalRef = this.modalService.open(template,
      { ariaLabelledBy: 'modal-basic-title', size: 'sm', centered: true, windowClass: ' audiometryResult_mdl' })

    return modalRef.result.then((result: any) => {
      return result;
    }).catch((error) => {
      console.log(error)
      return false;
    })
  }


  public deleteClaim() {
    this.loaderService.startLoadingIndicator('deleteClaim');
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId ? this.claimId : null;
    thisObj.claimsService.deleteClaim(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.modalService.dismissAll();
        this.loaderService.stopLoadingIndicator('deleteClaim');
        this.successText = 'Claim deleted';
        this.showMessage('success', 2000)
        // this.kmodalService.setIsOpen('deleteClaimModal',false);
        setTimeout(() => {
          this.router.navigate(['/claims']);
        }, 2005);
      }
    });
  }

  public showMessage(msgType: any, timeout: any) {
    this.displaySuccess = false;
    if (msgType === 'success') {
      this.displaySuccess = true;
    }
    if (msgType === 'error') {
      this.displayError = true;
    }
    if (timeout) {
      this.timeout = timeout;
    }
  }

  public closeDeleteClaimModal() {
    // this.kmodalService.setIsOpen('deleteClaimModal',false);
  }

  public getRightsByToken() {
    let getRightsParam = [{ actionObject: 'Claims', actionVerb: ['Delete'] }, { actionObject: 'MedicalRecords', actionVerb: ['Delete'] }];
    this.sharedService.getRightsByToken(getRightsParam).subscribe((result: any) => {
      result?.forEach((res: any) => {
        if (
          res.statusCode == 200 &&
          res.data.actionObject === 'Claims' &&
          res.data.actionVerb === 'Delete'
        ) {
          this.isDeleteClaimsAllowed = res.data.isAllowed;
        }
        if (
          res.statusCode == 200 &&
          res.data.actionObject === 'MedicalRecords' &&
          res.data.actionVerb === 'Delete'
        ) {
          this.isDeleteMedReportsAllowed = res.data.isAllowed;
        }
      },
        (err: any) => {
          console.log('error', err?.error);
        });
    });
  }

  createNewNIHLTest() {
    this.router.navigate(['nihl/investigation/create-audiometry/', this.claimId, this.createAudiometryTaskId]);
  }


  resetSearchMedicalRecordsFilterForm(form: any) {
    const thisObj = this;
    if (form.status === 'VALID') {
      form.reset();
      this.filter.searchKeyword = '';
      thisObj.getAllAudiometryTestList(this.filter.searchKeyword);
    }
  }

  submitSearchMedicalRecordsFilterForm($event: any, form: any) {
    const thisObj = this;
    if (form.status === 'VALID') {
      this.filter.searchKeyword = form.value.keyword;
      this.getAllAudiometryTestList(this.filter.searchKeyword)
      $event.preventDefault();
    }
  }

  viewAudiogram($event:any, audiogramTest: any) {
    $event.stopPropagation();
    this.router.navigate(['nihl/investigation/audiogram-analyse/', this.claimId, this.createAudiometryTaskId, audiogramTest._id]);
  }

  editAudiogram($event:any, audiogramTest: any) {
    $event.stopPropagation();
    this.router.navigate(['nihl/investigation/edit-audiometry/', this.claimId, this.createAudiometryTaskId, audiogramTest._id]);
  }

  deleteAudiogram(audiogramTest: any) {
    this.loaderService.startLoadingIndicator('deleteAudiogram');
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId ? this.claimId : null;
    requestParam.taskId = this.createAudiometryTaskId ? this.createAudiometryTaskId : null;
    requestParam.actionName = "delete_audiometry";
    requestParam.payload = {
      "id": audiogramTest._id
    }
    thisObj.nihlOutlineExposureService.deleteAudiogram(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.modalService.dismissAll();
        // this.kmodalService.setIsOpen('deleteNIHLTestModal',false);
        this.loaderService.stopLoadingIndicator('deleteAudiogram');
        if (result.data.isValid) {
          this.successText = 'Audiogram deleted successfully';
          this.showMessage('success', 2000);
          setTimeout(() => {
            this.displaySuccess = false;
          }, 2010);
        } else {
          this.errorText = result.data.errors;
          this.showMessage('error', 3000);
          setTimeout(() => {
            this.displayError = false;
          }, 2010);
        }
        this.getAllAudiometryTestList(null);
        this.getWorkflowOverview(this.claimId);
      }
    });
  }

  deleteNIHLTest() {
    this.deleteAudiogram(this.selectedTest)
  }

  closeDeleteNIHLTestModal() {
    // this.kmodalService.setIsOpen('deleteNIHLTestModal',false);
  }

  confirmDeleteNIHLTest($event:Event, audiogramTest: any) {

    $event.stopPropagation();

    this.selectedTest = audiogramTest;
    // this.kmodalService.setIsOpen('deleteNIHLTestModal',true);

    // let text = "Delete " +this.claimData?.claimant?.claimantName + "'s NIHL Test of type: " + this.selectedTest.type + " taken on " + moment(new Date(this.selectedTest.audiogramDate)).format('DD/MM/YYYY')+ "? This cannot be undone.";
    //   if (confirm(text) == true) {
    //     text = "You pressed OK!";
    //     this.deleteNIHLTest();
    //   } else {
    //     text = "You canceled!";
    //   }

    const modalRef = this.modalService.open(this.confirmDeleteTest,
      { ariaLabelledBy: 'modal-basic-title', size: 'sm', centered: true, windowClass: ' audiometryResult_mdl' })

    return modalRef.result.then((result: any) => {
      return result;
    }).catch((error) => {
      console.log(error)
      return false;
    })
  }
}
